import { useState } from 'react';

import { useUpdatePiecesMutation } from '@api/piece';
import { PieceAction } from '@apiContract';

import { ActionComponentProps } from '../../index';
import { DialogQrCodeConfirmation } from '../DialogQrCodeConfirmation';

export const FinishPickUpWithQrCode = ({ mailpieces, actionStarted, onActionFinish }: ActionComponentProps) => {
  const [updatePieces] = useUpdatePiecesMutation();

  const [actionInProgress, setActionInProgress] = useState<boolean>(false);

  const confirmFinishPickUp = async (qrCodeData: string) => {
    try {
      setActionInProgress(true);

      await updatePieces({
        pieces: mailpieces.map((piece) => ({ id: piece.id })),
        action: PieceAction.FinishPickUpWithQrCode,
        qrCode: qrCodeData,
      }).unwrap();

      setActionInProgress(false);
      onActionFinish();
    } catch (error) {
      setActionInProgress(false);
      onActionFinish();
    }
  };

  return (
    <DialogQrCodeConfirmation
      mailpieces={mailpieces}
      actionStarted={actionStarted}
      actionRequestInProgress={actionInProgress}
      onQrCodeRecognized={confirmFinishPickUp}
      onActionFinish={onActionFinish}
    />
  );
};
